// Jada & Jon: scroll reveals, stitched-line drawing, and the mobile inquire pill.
(function () {
  // In the theme editor, sections are redrawn after every change; show everything right away so nothing stays hidden.
  var inEditor = window.Shopify && window.Shopify.designMode;
  var io = !inEditor && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  var reveal = function (root) {
    root.querySelectorAll('.jj-reveal, .jj-stitch--draw').forEach(function (t) {
      if (io) io.observe(t); else t.classList.add('is-in');
    });
  };
  reveal(document);
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });

  var pill = document.querySelector('.jj-sticky-inquire');
  if (pill) {
    var onScroll = function () {
      var footer = document.querySelector('.footer');
      var nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
      pill.classList.toggle('is-on', window.scrollY > window.innerHeight * 0.7 && !nearFooter);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

// Forms: chip groups become one labelled field; single-choice groups act like radios.
(function () {
  document.querySelectorAll('form.jj-form').forEach(function (form) {
    form.querySelectorAll('.jj-chips[data-combine]').forEach(function (group) {
      var name = group.getAttribute('data-combine');
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = group.hasAttribute('data-prop') ? 'properties[' + name + ']' : 'contact[' + name + ']';
      group.appendChild(hidden);
      var boxes = group.querySelectorAll('input[type="checkbox"]');
      var sync = function () {
        hidden.value = Array.prototype.filter.call(boxes, function (b) { return b.checked; })
          .map(function (b) { return b.value; }).join(', ');
        hidden.disabled = hidden.value === '';
      };
      boxes.forEach(function (box) {
        box.addEventListener('change', function () {
          if (group.hasAttribute('data-single') && box.checked) {
            boxes.forEach(function (other) { if (other !== box) other.checked = false; });
          }
          sync();
        });
      });
      sync();
    });
    // If someone comes back with the browser's Back button, give them their blank fields back.
    window.addEventListener('pageshow', function () {
      form.querySelectorAll('[name^="contact["]:not([type="hidden"]):disabled, [name^="properties["]:not([type="hidden"]):disabled').forEach(function (el) { el.disabled = false; });
    });
    // Don't send blank answers: they show up as empty lines on the order or email.
    // Only our own answer fields are touched; Shopify's spam check (CAPTCHA) adds its own fields that must be left alone.
    form.addEventListener('submit', function () {
      form.querySelectorAll('[name^="contact["], [name^="properties["]').forEach(function (el) {
        if (el.type === 'hidden' || el.type === 'checkbox' || el.required || el.name === 'contact[email]') return;
        var empty = el.type === 'file' ? !(el.files && el.files.length) : !String(el.value).trim();
        if (empty) el.disabled = true;
      });
    });
  });
})();

// File drop tiles (forms and the custom product request): show the chosen file's name.
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input.matches || !input.matches('.jj-drop input[type="file"]')) return;
  var drop = input.closest('.jj-drop');
  var label = drop.querySelector('[data-file-label]');
  var file = input.files && input.files[0];
  drop.classList.toggle('has-file', !!file);
  if (label) label.textContent = file ? file.name : 'Tap to add';
});

// Custom products: the description is required, and unused photo slots are left out so the order has no blank lines.
// Runs in the capture phase, before the theme's own add-to-cart handler reads the form.
document.addEventListener('submit', function (e) {
  // getAttribute: the product form has an input named "id", which shadows form.id
  var formId = e.target.getAttribute && e.target.getAttribute('id');
  if (!formId) return;
  var box = document.querySelector('[data-jj-request] textarea[form="' + formId + '"]');
  if (!box) return;
  var wrap = box.closest('[data-jj-request]');
  var err = wrap.querySelector('.jj-preq__err');
  if (!box.value.trim()) {
    e.preventDefault();
    e.stopImmediatePropagation();
    wrap.classList.add('is-missing');
    if (!err) {
      err = document.createElement('p');
      err.className = 'jj-preq__err';
      err.textContent = 'Tell us a little about what you want first.';
      box.insertAdjacentElement('afterend', err);
    }
    box.focus();
    return;
  }
  wrap.classList.remove('is-missing');
  if (err) err.remove();
  var empties = Array.prototype.filter.call(wrap.querySelectorAll('input[type="file"]'), function (f) { return !f.files || !f.files.length; });
  empties.forEach(function (f) { f.disabled = true; });
  setTimeout(function () { empties.forEach(function (f) { f.disabled = false; }); }, 0);
}, true);

// Instagram film strip: swap the hand-picked frames for the latest posts from the Behold feed (data-jj-feed).
// The feed is only fetched once the strip is near the screen and is kept for 30 minutes, because Behold counts
// every fetch; if anything goes wrong the hand-picked frames simply stay.
(function () {
  var short = function (text) {
    text = String(text || '').split('\n')[0].trim();
    if (text.length <= 42) return text;
    var cut = text.slice(0, 42);
    cut = cut.slice(0, cut.lastIndexOf(' ')) || cut;
    return cut.replace(/[\s,.;:!?\u2014-]+$/, '') + '\u2026';
  };
  document.querySelectorAll('[data-jj-feed]').forEach(function (film) {
    var url = film.getAttribute('data-jj-feed');
    var tiles = (film.getAttribute('data-jj-film-tiles') || '').split('|');
    var max = parseInt(film.getAttribute('data-jj-feed-max'), 10) || 6;
    var track = film.querySelector('.jj-film__track');
    if (!url || !track) return;
    var render = function (posts) {
      posts = (posts || []).filter(function (p) { return p.permalink && p.sizes && p.sizes.medium && p.sizes.medium.mediaUrl; }).slice(0, max);
      if (!posts.length) return;
      track.textContent = '';
      posts.forEach(function (p, i) {
        var caption = short(p.prunedCaption || p.caption);
        var fig = document.createElement('figure');
        fig.className = 'jj-film__frame';
        var link = document.createElement('a');
        link.className = 'jj-film__link';
        link.href = p.permalink;
        link.target = '_blank';
        link.rel = 'noopener';
        var cell = document.createElement('div');
        cell.className = 'jj-film__cell';
        cell.style.setProperty('--film', "url('" + tiles[i % tiles.length] + "')");
        var img = document.createElement('img');
        img.src = p.sizes.medium.mediaUrl;
        img.srcset = ['small', 'medium', 'large'].filter(function (k) { return p.sizes[k] && p.sizes[k].mediaUrl; })
          .map(function (k) { return p.sizes[k].mediaUrl + ' ' + p.sizes[k].width + 'w'; }).join(', ');
        img.sizes = '(min-width: 990px) 30vw, 75vw';
        img.width = p.sizes.medium.width;
        img.height = p.sizes.medium.height;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = caption || 'Jada & Jon on Instagram';
        img.style.objectPosition = '50% 30%';
        cell.appendChild(img);
        link.appendChild(cell);
        fig.appendChild(link);
        if (caption) {
          var cap = document.createElement('figcaption');
          cap.className = 'jj-hand';
          cap.textContent = caption;
          fig.appendChild(cap);
        }
        track.appendChild(fig);
      });
    };
    var load = function () {
      var key = 'jj-feed:' + url;
      var cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
      if (cached && Date.now() - cached.t < 30 * 60 * 1000) { render(cached.posts); return; }
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error('feed ' + r.status);
        return r.json();
      }).then(function (d) {
        var posts = (d && d.posts) || [];
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), posts: posts })); } catch (e) {}
        render(posts);
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(film);
    } else {
      load();
    }
  });
})();
